module.exports = __webpack_public_path__ + "img/avatar.da21f8ac.svg";